<template>
  <div class="repeat-table">
    <a-table
      v-if="!loading && newList && newList.length"
      :columns="columns"
      :data-source="newList"
      :pagination="false"
      row-key="inquiryid"
    >
      <span
        slot="code"
        slot-scope="text, record, index"
        class="code"
        :class="{btn: inquiryCheckRepeatView}"
        @click="handlerDetail(text, record, index)"
      >{{ text.code }}</span>
      <span
        slot="contact_info_company_name"
        slot-scope="text"
      >
        {{ text.fieldvalue || '- -' }}
      </span>
      <div
        slot="contact_info_contact_mobile"
        slot-scope="text"
        class="contact-mobile"
      >
        {{ (text && text.length && text.join(',')) || '- -' }}
      </div>
      <div
        slot="contact_info_contact_email"
        slot-scope="text"
        class="contact-email"
      >
        {{ (text && text.length && text.join(',')) || '- -' }}
      </div>
      <a
        v-if="inquiryCheckRepeatView"
        slot="action"
        slot-scope="text, record, index"
        href="javascript:;"
        @click="handlerDetail(text, record, index)"
      >{{ $t('message["89"]') }}</a>
    </a-table>
    <a-spin
      v-else-if="searched && loading"
      class="spin-fixed-center"
    />
    <pagination
      v-if="newList && newList.length"
      ref="pagination"
      :pagination="pagination"
      @change="handlePage"
    />
    <div
      v-show="searched && !loading && (!list || !list.length)"
      class="empty-box"
    >
      <i class="iconfont iconicon-test38 logo" />
      <p class="placeholder">
        {{ $t('message["93"]') }}
      </p>
      <a-button
        type="primary"
        @click="onClickAdd"
      >
        {{ $t('message["622"]') }}
      </a-button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { getEncode } from '@/lib/mix'
import { setCodeData } from '@/lib/utils'
import Pagination from '@/components/pc/Pagination'

export default {
  components: {
    Pagination
  },
  props: {
    /* searched: {
      type: Boolean,
      default: false
    }, */
    checkrepeatfieldkey: {
      type: String,
      default: ''
    },
    checkrepeatfieldvalue: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      inquiryCheckRepeatView: false
    }
  },
  computed: {
    ...mapState('inquery/repeatData', [
      'loading',
      'searched',
      'searchConfig',
      'list',
      'pagination'
    ]),
    ...mapGetters('inquery/repeatData', [
      'newList',
      'columns'
    ]),
    pid () {
      return this.$route.params.pid
    }
  },
  watch: {
    $route (to, from) {
      this.getRepeatList()
    }
  },
  created () {
    this.clearList()

    let fieldkey = this.searchConfig.key || this.checkrepeatfieldkey
    let fieldvalue = this.searchConfig.value || this.checkrepeatfieldvalue
    if (fieldkey && fieldvalue !== '') {
      this.getRepeatList()
    }
  },
  methods: {
    ...mapActions('inquery/repeatData', ['fetchList', 'clearList']),
    async getRepeatList (params = {}) {
      params.fieldkey = this.searchConfig.key || this.checkrepeatfieldkey
      params.fieldvalue = this.searchConfig.value || this.checkrepeatfieldvalue

      if (params.fieldvalue) {
        const enCode = await getEncode()
        params.fieldvalue = await setCodeData(params.fieldvalue, enCode)
      }
      const chain = await this.fetchList()
      chain
        .params({
          ...params,
          page: this.pagination.currentPage,
          limit: this.pagination.pageSize,
          device: 1
        })
        .onSuccess((res, raw) => {
          const { permissions = {} } = raw
          this.inquiryCheckRepeatView = permissions['inquiry-check-repeat-view']
        })
        .fetch()
    },

    handlePage (pagination) {
      this.pagination.currentPage = pagination.currentPage
      this.$router.push({
        name: 'InqueryRepeat',
        query: {
          ...this.$route.query,
          page: pagination.currentPage,
          limit: pagination.pageSize,
          _t: new Date().getTime()
        }
      })
      // this.getRepeatList()
    },

    handlerDetail (text, record, index) {
      if (!this.inquiryCheckRepeatView) return

      this.$router.push({
        // path: `/project/${this.pid}/inquery/detail/${record.inquiryid}`,
        name: record.status === 1 ? 'InqueryPassDetail' : 'InqueryDetail',
        params: {
          pid: this.pid,
          inquiryId: record.inquiryid
        },
        query: {
          ...this.$route.query,
          from: 'checkrepeat',
          checkrepeatfieldkey: this.checkrepeatfieldkey
        }
      })
    },
    onClickAdd () {
      this.$router.push({
        name: 'InqueryCreate',
        query: {
          checkrepeatfieldkey: this.checkrepeatfieldkey,
          checkrepeatfieldvalue: this.checkrepeatfieldvalue
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ant-table-wrapper {
  padding-top: 24px;
  .contact-mobile, .contact-email {
    word-break: break-all;
  }
}
::v-deep .ant-table-placeholder {
  display: none;
}
.empty-box {
  text-align: center;
  .logo {
    display: block;
    margin: 40px auto 8px;
    font-size: 24px;
    color: #d6d6d6;
  }
  .placeholder {
    margin-bottom: 16px;
    color: $gray3;
  }
}
</style>
